import { getMuciifiOrigin } from "@/lib/origin";
import { Building2, Link2, ArrowRight } from "lucide-react";

export default function BrandNotFoundPage() {
    const url = new URL(getMuciifiOrigin())
    url.pathname ="accommodations"
    const accommodationsUrl = url.toString()

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-50 p-4">
  <div className="w-full max-w-md text-center">
    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
      <Building2 className="h-6 w-6 text-gray-500" aria-hidden="true" />
    </div>

    <h1 className="mt-5 text-2xl font-bold text-gray-900">
      Property site not found
    </h1>

    <p className="mt-2 text-sm leading-6 text-gray-600">
      We couldn't find a Muciifi property site at this address. The link may
      be incorrect, or the property site may have been removed.
    </p>

    <div className="mt-5 rounded-lg border border-gray-200 bg-white p-4 text-left">
      <div className="flex gap-3">
        <Link2 className="mt-0.5 h-5 w-5 shrink-0 text-gray-400" />
        <div>
          <p className="text-sm font-medium text-gray-900">
            Double-check the link
          </p>
          <p className="mt-1 text-sm text-gray-500">
            Make sure the property address was typed or copied correctly.
          </p>
        </div>
      </div>
    </div>

    <a
      href={accommodationsUrl}
      className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-gray-800"
    >
      <Building2 className="h-4 w-4" aria-hidden="true" />
      Browse Muciifi properties
      <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </a>

    <p className="mt-4 text-xs text-gray-400">
      Looking for a different property? Start from Muciifi and discover
      available accommodations.
    </p>
  </div>
</div>
  )
}
